module.exports = __webpack_public_path__ + "7faf5654ec64addbb319ed1c50dd03a8.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/header/components/images/collection.png
 ** module id = 1395
 ** module chunks = 0
 **/